/**
 * Sonidos del Tablero de Ventas y de los festejos (Esteban, 3-nov-2026): cada equipo suena distinto cuando vende, el rebase en el
 * podio tiene su fanfarria y el Bombazo su redoble. Son clips cortos en public/sonidos (los eligió él por oído):
 * lobo (Alpha), diamante (Diamond), ateneas, fuego (Fénix), jaguar, aguila (Águilas), fanfarria (Admisiones), sube (rebase), bombazo.
 * Nunca se enciman: `secuencia` toca uno tras otro. Si un clip no carga, no truena.
 */
const BASE = (process.env.PUBLIC_URL || "") + "/sonidos/";
const VOL: { [k: string]: number } = { jaguar: .9, lobo: .9, aguila: .7, fuego: .8, diamante: .7, ateneas: .8, fanfarria: .7, bombazo: .9, sube: .6 };
const cache: { [k: string]: HTMLAudioElement } = {};

/** Precarga un clip (para que el primero no tarde). */
export const precargar = (nombre: string): void => {
	if (!nombre || cache[nombre]) return;
	try {
		const a = new Audio(BASE + nombre + ".mp3");
		a.preload = "auto";
		cache[nombre] = a;
	} catch { /* sin audio */ }
};

/** Toca un clip y resuelve cuando termina (o enseguida si no se pudo). */
export const tocar = (nombre: string): Promise<void> => new Promise((listo) => {
	if (!nombre) { listo(); return; }
	try {
		precargar(nombre);
		const a = cache[nombre].cloneNode(true) as HTMLAudioElement;
		a.volume = VOL[nombre] ?? .7;
		let fin = false;
		const acabar = () => { if (!fin) { fin = true; listo(); } };
		a.addEventListener("ended", acabar);
		a.addEventListener("error", acabar);
		// Por si el navegador nunca avisa "ended" (pestaña dormida): tope de 12 s.
		setTimeout(acabar, 12000);
		a.play().catch(acabar);
	} catch { listo(); }
});

/** Uno tras otro, nunca encimados: primero el del equipo y, si rebasó, la fanfarria del rebase. */
export const secuencia = async (nombres: (string | null | undefined)[]): Promise<void> => {
	for (const n of nombres) {
		if (n) await tocar(n);
	}
};
